import { atom } from 'jotai';

export const tenantNameAtom = atom<string | null>(null);
